import CONFIG from '../../configs/config';

export default {
    login: function (user) {
        return {type: 'SESSION_LOGIN', user};
    },
    logout: function () {
        return {type: 'SESSION_LOGOUT'};
    },
    setConnectionStatus: function (connected) {
        return {type: 'SESSION_SET_API_CONNECTION_STATUS', connected};
    },
    updatesReceived: function (updates) {
        return {
            type: 'SESSION_UPDATES',
            updates,
            updatesInterval: CONFIG.forceUpdateInterval || updates.update_interval_seconds * 1000 || null,
        };
    },
    prefill: function (summary) {
        return {type: 'SESSION_PREFILL', summary};
    },
    clearPrefill: function () {
        return {type: 'SESSION_CLEAR_PREFILL'};
    },
};
